import { useEffect, useState } from "react";

// Conteneurs capturés par les crochets montés (une feuille ouverte chacun). Un seul observateur
// surveille leur retrait du document : une feuille fermée se démonte, et le portail d'un menu qui
// l'avait prise pour conteneur rendrait alors dans un nœud détaché (menu invisible, body verrouillé
// par la couche Radix du menu : plus rien ne se clique). Chaque crochet oublie son conteneur dès
// qu'il quitte le document.
const abonnes = new Map();
let observateur = null;
function surveillerLeRetrait(element, abonne) {
  let ensemble = abonnes.get(element);
  if (!ensemble) {
    ensemble = new Set();
    abonnes.set(element, ensemble);
  }
  ensemble.add(abonne);
  if (!observateur && typeof MutationObserver !== "undefined") {
    observateur = new MutationObserver(() => {
      for (const [el, ens] of abonnes) {
        if (!el.isConnected) {
          for (const a of ens) {
            a();
          }
        }
      }
    });
    observateur.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  return () => {
    ensemble.delete(abonne);
    if (ensemble.size === 0) {
      abonnes.delete(element);
    }
    if (abonnes.size === 0 && observateur) {
      observateur.disconnect();
      observateur = null;
    }
  };
}
export function useSheetContainer(mountPortalContainer) {
  const [container, setContainer] = useState(mountPortalContainer);
  useEffect(() => {
    if (mountPortalContainer) {
      setContainer(mountPortalContainer);
      return;
    }
    if (!container) {
      const dialogElements = document.querySelectorAll(".sheet[role=dialog][data-state=open]");
      const lastDialog = dialogElements[dialogElements.length - 1];
      if (lastDialog) {
        setContainer(lastDialog);
      }
      return;
    }
    if (!container.isConnected) {
      setContainer(undefined);
      return;
    }
    return surveillerLeRetrait(container, () => setContainer(undefined));
  }, [container, mountPortalContainer]);
  return container;
}
//# sourceMappingURL=useSheetContainer.js.map